import React, { useState, useEffect } from 'react'

import { Button, Icon, Payment } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, bool } from 'prop-types'

import useGA4ItemTracking from 'Pods/ItemPage/Hooks/useGA4ItemTracking'
import useApiPost from 'Pods/Shared/Hooks/useApiPost'
import useSentry from 'Pods/Shared/Hooks/useSentry'

function BuyNowButton({ productId, disabled = false }) {
  const [isRedirecting, setIsRedirecting] = useState(false)
  const { captureException } = useSentry()
  const { postData, isLoading: isPostDataLoading } = useApiPost()
  const { trackBuyNow } = useGA4ItemTracking()

  // bfcache restores the page with isRedirecting still true from before the redirect.
  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        setIsRedirecting(false)
      }
    }

    window.addEventListener('pageshow', handlePageShow)
    return () => window.removeEventListener('pageshow', handlePageShow)
  }, [])

  const handleBuyNowClick = () => {
    postData({
      path: `/api/internal/cg/items/${productId}/cart_items`,
      onSuccess: (response) => {
        const cartItemId = response?.data?.data?.id

        if (!cartItemId) {
          window.showNotification('Failed to process purchase', {
            type: 'error',
            autohide: true,
          })
          return
        }

        trackBuyNow()

        setIsRedirecting(true)
        sessionStorage.setItem('buyNowCartItemId', cartItemId)
        sessionStorage.setItem('buyNowProductId', productId)
        window.location.href = `/cg/checkout/payment?buy_now=${cartItemId}`
      },
      onError: (error) => {
        const errorMessage = error?.response?.data?.errors?.detail || 'Failed to add item to cart'
        window.showNotification(errorMessage, {
          type: 'error',
          autohide: true,
        })
        captureException(error)
      },
    })
  }

  return (
    <Button
      type="primary-warning"
      customClass="pricing-area__actions-button pricing-area__actions-right-button"
      size="large"
      trailIcon={<Icon svgComponent={Payment} />}
      onClick={handleBuyNowClick}
      disabled={disabled || isPostDataLoading || isRedirecting}
      aria-label="Buy now"
    >
      Buy now
    </Button>
  )
}

BuyNowButton.propTypes = {
  productId: number.isRequired,
  disabled: bool,
}

export default BuyNowButton
